import globalStore from '@/services/global.state';
import {goTo} from '@/utils';
import React from 'react';
import {currentBrand} from '@/brands';
import {ReactComponent as HomeIcon} from '@/assets/icons/home/navbar/home.svg';
import {ReactComponent as ResultIcon} from '@/assets/icons/home/navbar/result.svg';
import {ReactComponent as InviteIcon} from '@/assets/icons/home/navbar/promotions.svg';
import {ReactComponent as AccountIcon} from '@/assets/icons/home/navbar/account.svg';
import imgRewardBg from './tab-center.png';

interface NavbarProps {
  activeTab?: 'home' | 'casino' | 'referral' | 'me';
  onTabChange?: (tab: 'home' | 'casino' | 'referral' | 'me') => void;
  onRewardClick?: () => void;
  list: any[];
  state: any;
  descriptors: any;
}

const Navbar: React.FC<NavbarProps> = ({
  list = [],
  state,
  descriptors,
  onRewardClick,
}) => {
  const activeTab = list[state.index].name;
  const isAnna = currentBrand.key === 'anna';
  const activeColor = currentBrand.theme.basicColor?.primary as string;
  const inactiveColor = currentBrand.theme.fontColor?.accent as string;
  const half = Math.floor(state?.routes.length / 2);
  const prevList = state?.routes.slice(0, half);
  const nextList = state?.routes.slice(half + 1);
  const renderAnnaIcon = (tabName: string, isFocused: boolean) => {
    const color = isFocused ? activeColor : inactiveColor;
    const className = 'w-6 h-6';

    switch (tabName) {
      case 'Home':
        return <HomeIcon className={className} style={{color}} />;
      case 'Result':
        return <ResultIcon className={className} style={{color}} />;
      case 'Referral':
        return <InviteIcon className={className} style={{color}} />;
      case 'Me':
        return <AccountIcon className={className} style={{color}} />;
      default:
        return null;
    }
  };

  const renderTabs = (lists: any[], offset = 0) => {
    return lists.map((tab, index) => {
      const {options} = descriptors[tab.key];
      const name = options.title;
      const tabName = tab.name;
      const isFocused = tabName === activeTab;
      const onPress = () => {
        if (!isFocused) {
          if (tabName === 'MySports') {
            globalStore.openSports.next(undefined);
          } else if (tabName === 'Referral' && !globalStore.token) {
            goTo('Login');
          } else if (tabName === 'Promotions') {
            goTo('PromotionsV2', {tabKey: 'promotion'});
          } else if (tabName === 'jackpot') {
            goTo('Leaderboard', {type: 'OLD_USER_RANK_ACTIVITY'});
          } else {
            goTo(tab.name);
          }
        }
      };
      const offsetIndex = index + offset;
      const icon = isFocused
        ? list[offsetIndex].activeImg
        : list[offsetIndex].img;
      return (
        <div
          key={tab.id}
          className="flex-1 flex flex-col justify-center items-center text-xs cursor-pointer"
          onClick={() => onPress()}>
          {isAnna ? (
            renderAnnaIcon(tabName, isFocused)
          ) : (
            <div className="w-6 h-6">
              <img alt={tab.label} className="w-full h-full" src={icon} />
            </div>
          )}
          <p
            className="text-[10px] font-bold tracking-[-0.5px] text-center"
            style={{color: isFocused ? activeColor : inactiveColor}}>
            {name}
          </p>
        </div>
      );
    });
  };
  const renderCenter = () => {
    const path = 'ScratchNew';
    const isFocused = activeTab === path;
    return (
      <div
        className="flex flex-col items-center gap-1 cursor-pointer flex-1 relative"
        onClick={() => {
          if (!isFocused) {
            goTo(path);
          }
        }}>
        <div className="absolute left-1/2 bottom-[20px] transform -translate-x-1/2">
          <div className="w-[64px] h-[64px] bg-white rounded-full flex items-center justify-center">
            <div
              className="w-[50px] h-[50px] bg-[#ea3e41] rounded-full shadow-[0px_3.505px_10.514px_0px_rgba(234,62,99,0.5)] cursor-pointer flex items-center justify-center"
              onClick={onRewardClick}>
              <div
                className="inset-0 bg-cover bg-center bg-no-repeat w-[44px] h-[44px] transform scale-150"
                style={{backgroundImage: `url('${imgRewardBg}')`}}
              />
            </div>
          </div>
        </div>
        <div className="w-6 h-6" />
        <div
          className="text-[10px] font-bold tracking-[-0.5714px] text-center"
          style={{color: isFocused ? activeColor : inactiveColor}}>
          Get ₹200
        </div>
      </div>
    );
  };

  if (isAnna) {
    return (
      <div className="absolute bottom-0 z-40 flex h-14 w-full bg-white border-t border-black/5 shadow-[0_-1px_4px_0_rgba(0,0,0,0.05)]">
        {renderTabs(state?.routes)}
      </div>
    );
  }

  return (
    <div className="absolute bottom-0 w-full h-[56px] flex items-center justify-between bg-white">
      {/* 奖励按钮 */}
      {renderTabs(prevList)}
      {renderCenter()}
      {renderTabs(nextList, half + 1)}
    </div>
  );
};

export default Navbar;
